import { Combobox, Tag } from "@appkit4/react-components";
import { SelectValue } from "@appkit4/react-components/esm/combobox/Combobox";
import { FC, useState, useCallback, useEffect } from "react";
import { SapSystem } from "routes/analysis/types/analysis";
import { FetchSystems } from "routes/administration/queries/system";

interface SystemSelectProps {
  clientId: string;
  selected: string[];
  onSelect: (value: SapSystem[]) => void;
}

const SystemSelect: FC<SystemSelectProps> = ({ clientId, selected, onSelect }) => {
  const [selectedSystems, setSelectedSystems] = useState<SapSystem[]>();
  const { data: systems, isPending: isSystemPending } = FetchSystems(clientId);

  const renderSystemValues = (value: SelectValue) => {
    if (Array.isArray(value))
      if (value.length > 0)
        return value.map((v, i) => <Tag
          key={i}
          className="ap-badge-process"
          closable={false}
        >{systems?.find(f => f.systemId === v)?.sapNickname}</Tag>);
  }

  const initSelected = useCallback(() => {
    if (!systems) return;
    setSelectedSystems(systems?.filter(f => selected.includes(f.systemId as string)));
    onSelect(systems?.filter(f => selected.includes(f.systemId as string)) || []);
  }, [selected, systems, onSelect]);

  useEffect(() => {
    if (!isSystemPending) {
      initSelected();
    }
  }, [isSystemPending, initSelected]);
  
  return (
    <Combobox
      multiple
      placeholder="Systems"
      data={systems?.map(m => ({ value: m.systemId, label: m.sapNickname }))}
      style={{ marginTop: 16, marginBottom: 16 }}
      value={selectedSystems?.map(m => m.systemId) as string[] || []}
      valueTemplate={renderSystemValues}
      onSelect={(value) => {
        if (!value) return;
        if (Array.isArray(value)) {
          onSelect(systems?.filter(f => f.systemId && value.includes(f.systemId)) || []);
          setSelectedSystems(systems?.filter(f => f.systemId && value.includes(f.systemId)) || []);
        } else {
          onSelect(systems?.filter(f => f.systemId === value) || []);
          setSelectedSystems(systems?.filter(f => f.systemId === value) || []);
        }
      }}
    />
  )
}

export default SystemSelect;
